import { render, staticRenderFns } from "./NewsCardComments.vue?vue&type=template&id=7a847496&scoped=true&"
import script from "./NewsCardComments.vue?vue&type=script&lang=js&"
export * from "./NewsCardComments.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardComments.vue?vue&type=style&index=0&id=7a847496&lang=scss&scoped=true&"
import style1 from "./NewsCardComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a847496",
  null
  
)

export default component.exports